/**
 * "Read up to" time per mission on this device: important alerts newer than this count on the bell.
 * Opening the alert list marks everything read — no per-alert acknowledgement is needed.
 */
import { create } from 'zustand';
import type { Id } from '@apos/shared';
import { safeGet, safeSet } from '../../lib/prefs';

const KEY = 'apos.alerts.seen.v1';

function load(): Record<Id, number> {
  try {
    const v = JSON.parse(safeGet(KEY) ?? '{}') as unknown;
    return v && typeof v === 'object' ? (v as Record<Id, number>) : {};
  } catch {
    return {};
  }
}

interface AlertSeen {
  seen: Record<Id, number>;
  markSeen(missionId: Id, t: number): void;
}

export const useAlertSeen = create<AlertSeen>((set, get) => ({
  seen: load(),
  markSeen(missionId, t) {
    if ((get().seen[missionId] ?? 0) >= t) return;
    const seen = { ...get().seen, [missionId]: t };
    safeSet(KEY, JSON.stringify(seen));
    set({ seen });
  },
}));
